import { greenBright } from 'chalk';

const text = `
╔═╗╦═╗╦ ╦╔═╗╔╦╗╔═╗╦ ╦╔═╗╔╦╗╔═╗╦ ╦
║  ╠╦╝╚╦╝╠═╝ ║ ║ ║║║║╠═╣ ║ ║  ╠═╣
╚═╝╩╚═ ╩ ╩   ╩ ╚═╝╚╩╝╩ ╩ ╩ ╚═╝╩ ╩
`;

const logo = greenBright(text);

export default logo;
